<div class="my-show-table">
  <div class="audit-summary">

  <div class="summary-card">
    <span class="title">User Name</span>
    <span class="value">{{ userName }}</span>
  </div>

  <div class="summary-card">
    <span class="title">User Email</span>
    <span class="value">{{ userEmail }}</span>
  </div>

  <div class="summary-card">
    <span class="title">Total Logs</span>
    <span class="value">{{ pagination.total || "-"}}</span>
  </div>

</div>

  <div class="mat-elevation-z8">
    

    <table mat-table [dataSource]="logs">
      

      <!-- <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element">
          {{element.id}}
        </td>
      </ng-container> -->


      <ng-container matColumnDef="targeted_email">
        <th mat-header-cell *matHeaderCellDef>Targeted Email</th>
        <td mat-cell *matCellDef="let element">
          {{element.targeted_email}}
        </td>
      </ng-container>


      <ng-container matColumnDef="performed_by">
        <th mat-header-cell *matHeaderCellDef> Performed By </th>
        <td mat-cell *matCellDef="let element">
          {{element.performed_by || 'Unknown User'}}
        </td>
      </ng-container>


      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element">
          {{element.action}}
        </td>
      </ng-container>


      <ng-container matColumnDef="added at">
        <th mat-header-cell *matHeaderCellDef> Added At </th>
        <td mat-cell *matCellDef="let element">
          {{element.created_at  | date:'MMM d, y, h:mm a'}}
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="logsDisplayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: logsDisplayedColumns;"></tr>

       <tr class="mat-row" *matNoDataRow>
        <td colspan="5" class="mat-cell">
          {{loading ? 'Loading...' : 'No logs found.'}}
        </td>
      </tr>

      

    </table>
    <mat-paginator
    [length]="pagination.total"
    [pageSize]="pagination.limit"
    [pageSizeOptions]="[5, 10, 25, 50]"
    (page)="pageChange($event)">
</mat-paginator>

  </div>

</div>  